import { UserButton } from '@clerk/react';

const AccountMenu = () => (
  <UserButton
    afterSignOutUrl="/"
    userProfileMode="modal"
    appearance={{
      elements: {
        organizationSwitcherTrigger: { display: 'none' },
        userButtonPopoverActionButton__manageOrganization: { display: 'none' },
        organizationPreview: { display: 'none' },
      },
    }}
  >
    <UserButton.MenuItems>
      <UserButton.Action label="manageAccount" />
      <UserButton.Action label="signOut" />
    </UserButton.MenuItems>
  </UserButton>
);

export default AccountMenu;
